import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "ec-8179f387-db75-4c7f-8eb1-f27822dae38d-__Layer_25",
  height: "48px",
  viewBox: "0 0 1024 1024",
  width: "48px",
  "data-name": "Layer 25",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "512",
      cy: "512",
      fill: "#e6e6e6",
      r: "512"
    }, null, -1),
    _createElementVNode("path", { d: "M 701.952 629.248 C 721.92 649.216 721.92 681.472 701.952 701.44 C 691.712 711.68 678.912 716.288 665.6 716.288 C 652.288 716.288 639.488 711.168 629.248 701.44 L 512 584.192 L 394.752 701.44 C 384.512 711.68 371.712 716.288 358.4 716.288 C 345.088 716.288 332.288 711.168 322.048 701.44 C 302.08 681.472 302.08 649.216 322.048 629.248 L 439.296 512 L 322.048 394.752 C 302.08 374.784 302.08 342.528 322.048 322.56 C 342.016 302.592 374.272 302.592 394.24 322.56 L 511.488 439.808 L 628.736 322.56 C 648.704 302.592 680.96 302.592 700.928 322.56 C 720.896 342.528 720.896 374.784 700.928 394.752 L 583.68 512 L 700.928 629.248 L 701.952 629.248 Z" }, null, -1)
  ]))]))
}
export default { render: render }